
import GlassDesignerAPIService from '@/apps/glass-designer/src/services/apiService'

import StoreEditorLibrary from './store/modules/editorLibrary'

export default class AdminModule {
  constructor() {
  }

  install(Vue, options = {}) {
    // Services
    Vue.prototype.$apiService.glassDesignerService = new GlassDesignerAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)

    // Glass Editor App - Store
    options.store.registerModule(['apps', 'editorLibrary'], StoreEditorLibrary)
  }


  getRoutes() {
    return []
  }
}